import { CargoLocation, Settings } from '@/models/Settings';
import { fetcher } from './Requester';
import { CACHE_KEY, HTTP_REQUEST, SETTINGS_TYPE } from './Constants';
import { Endpoints } from './Endpoints';
import { loadSettings, setLocations } from './SettingsStorage';

export async function loadLocationsFromBackend(): Promise<CargoLocation | undefined> {
  try {
    const result = await fetcher<Settings>({
      params: {
        type: SETTINGS_TYPE.LOCATIONS,
      },
      cacheKey: CACHE_KEY.LOCATIONS,
      endpoint: Endpoints.SETTINGS,
      method: HTTP_REQUEST.GET,
      cacheEnabled: false,
    });
    if (!result?.homepage?.items) {
      return undefined;
    }
    const { cities, districts, otherCityId, otherCityTargetPath } = result.homepage.items;
    if (cities && cities.length > 0 && districts && districts.length > 0) {
      setLocations({ cities, districts, otherCityId, otherCityTargetPath });
      loadSettings();
      return { cities, districts } as CargoLocation;
    }
  } catch (e) {
    return undefined;
  }
}
